import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Rating } from 'app/shared/models/class/rating/rating';

@Component({
  selector: 'app-table-submovie',
  templateUrl: './table-submovie.component.html',
  styleUrls: ['./table-submovie.component.scss']
})
export class TableSubmovieComponent implements OnInit {

  @Input() subMovies!: Rating[];

  displayedColumnsDesktop: string[] = ['image', 'title', 'nbrOfRating', 'rating','disturbing'];
  dataSource!: MatTableDataSource<Rating>;

  constructor() { }

  ngOnInit(): void {
    this.initTable();
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource<Rating>(this.subMovies);
  }

}
